var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButtonOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 20,
    rx: 9.5,
    stroke: "#7C90B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 10.385C15.7 10.915 15.6117 11.4067 15.435 11.86C15.2617 12.31 15.015 12.7 14.695 13.03C14.375 13.36 13.99 13.6183 13.54 13.805C13.09 13.9883 12.59 14.08 12.04 14.08C11.4933 14.08 10.995 13.9883 10.545 13.805C10.095 13.6183 9.70833 13.36 9.385 13.03C9.065 12.7 8.81667 12.31 8.64 11.86C8.46333 11.4067 8.375 10.915 8.375 10.385C8.375 9.855 8.46333 9.365 8.64 8.915C8.81667 8.46167 9.065 8.07 9.385 7.74C9.70833 7.41 10.095 7.15333 10.545 6.97C10.995 6.78333 11.4933 6.69 12.04 6.69C12.4067 6.69 12.7517 6.73333 13.075 6.82C13.3983 6.90333 13.695 7.02333 13.965 7.18C14.235 7.33333 14.4767 7.52167 14.69 7.745C14.9067 7.965 15.09 8.21167 15.24 8.485C15.39 8.75833 15.5033 9.055 15.58 9.375C15.66 9.695 15.7 10.0317 15.7 10.385ZM14.325 10.385C14.325 9.98833 14.2717 9.63333 14.165 9.32C14.0583 9.00333 13.9067 8.735 13.71 8.515C13.5133 8.295 13.2733 8.12667 12.99 8.01C12.71 7.89333 12.3933 7.835 12.04 7.835C11.6867 7.835 11.3683 7.89333 11.085 8.01C10.805 8.12667 10.565 8.295 10.365 8.515C10.1683 8.735 10.0167 9.00333 9.91 9.32C9.80333 9.63333 9.75 9.98833 9.75 10.385C9.75 10.7817 9.80333 11.1383 9.91 11.455C10.0167 11.7683 10.1683 12.035 10.365 12.255C10.565 12.4717 10.805 12.6383 11.085 12.755C11.3683 12.8717 11.6867 12.93 12.04 12.93C12.3933 12.93 12.71 12.8717 12.99 12.755C13.2733 12.6383 13.5133 12.4717 13.71 12.255C13.9067 12.035 14.0583 11.7683 14.165 11.455C14.2717 11.1383 14.325 10.7817 14.325 10.385ZM18.2312 7.84V9.98H20.9412V11.055H18.2312V14H16.8812V6.77H21.4412V7.84H18.2312ZM23.8952 7.84V9.98H26.6052V11.055H23.8952V14H22.5452V6.77H27.1052V7.84H23.8952Z",
    fill: "#7C90B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonOff);
export default __webpack_public_path__ + "static/media/button_off.5bff259e.svg";
export { ForwardRef as ReactComponent };